import React, {useEffect, useState} from 'react';
import {cloneDeep} from "lodash";
import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import JobPipelineInputForm, {JobPipelineInputMode} from "@pages/jobpipeline/edit/JobPipelineInputForm";
import {pipelineOptionsToString, pipelineStringToOptions} from "@pages/jobpipeline/common/PipelineUtil";

const SearchMode = {
    PIPELINE_LIST: 1,
    RUN_JOB: 2,
}

const AdvanceSearchJobPipelineModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep({}));
    const [searching, setSearching] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {isShow, searchInput, mode, onClose, onSearch, showFullSearch} = props


    const onChangeSearchConditions = (changes) => {
        if (changes) {
            setSearchConditions({...searchConditions, ...changes})
        }
    }

    const onSearchClick = () => {
        onSearch(pipelineOptionsToString(searchConditions))
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        console.log("Advance Search input:" + JSON.stringify(searchInput))
        if (searchInput) {
            setSearchConditions(pipelineStringToOptions(searchInput))
        } else {
            setSearchConditions({})
        }
    }, [searchInput]);

    const onClearSearchCondition = () => {
        const fields = Object.keys(searchConditions)
        fields.forEach(f => {
            searchConditions[f] = ''
        })
        setSearchConditions({...searchConditions})
    }

    const onChangeInputItem = (values, column) => {
        searchConditions[column.key] = values
        setSearchConditions({...searchConditions})
    }

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Tìm kiếm job pipeline</Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    {!showFullSearch &&
                    <JobPipelineInputForm mode={JobPipelineInputMode.Search} onChangeInputItem={onChangeInputItem}
                                          pipeLineInfo={searchConditions}/>
                    }
                    {showFullSearch &&
                        <>

                            <JobPipelineInputForm mode={JobPipelineInputMode.Search} onChangeInputItem={onChangeInputItem}
                                                  pipeLineInfo={searchConditions}/>
                        </>

                    }
                    </Modal.Body>
                <Modal.Footer>
                    <button
                        type='submit'
                        className='btn btn-default'
                        onClick={() => onClearSearchCondition()}
                        disabled={searching}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={onSearchClick}
                        disabled={searching}
                    >
                        {searching ? 'Searching' : 'Search'}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AdvanceSearchJobPipelineModal;
